const state = () => (localStorage.getItem('order') ? JSON.parse(localStorage.getItem('order')) : {
  orderList: [],
})

const getters = {
  getOrderTotal: (state) => state.orderList.reduce((total, prev) => total += (Number.parseFloat(prev.price) * prev.quantity).toFixed(2) - 0, 0)
}

const mutations = {
  setOrder (state, orderList) {
    console.log('添加订单..', orderList)
    state.orderList = orderList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}